<template>
  <div class="biangeng">
    <nav>
      <div>
        欢迎使用中资云企业综合服务平台
      </div>
    </nav>
    <header>
      <div>
        <img src="../assets/imgs/authentication/logo.png" alt="">
        <span>变更资料</span>
      </div>
      <div class="kk" @click="goshouye">
        平台首页
      </div>
    </header>
    <div class="bgtj_sucess" v-if="step==1">
      <h2>企业信息</h2>
      <section class="lines"></section>
      <div class="nei">
        <div class="nei-t">
          <img src="../assets/imgs/authentication/complete.png" alt="">
          <p>企业信息变更提交成功</p>
        </div>
        <div class="nei-m">平台审核需要2~3日，请耐心等待</div>
        <div class="nei-b1">3秒后自动跳转</div>
        <div class="nei-b2">返回</div>
      </div>
    </div>
    <div v-if="step==0">
      <div class="tabbar">
        <div class="tabbox">
          <div class="tab1" :class="{active:step==0}">
            <div class="bg">1</div>
            <div class="text">企业详细信息</div>
          </div>
          <img src="../assets/imgs/register/line.png" alt="">
          <div class="tab1">
            <div class="bg">2</div>
            <div class="text">联系人信息</div>
          </div>
          <img src="../assets/imgs/register/line.png" alt="">
          <div class="tab1">
            <div class="bg">3</div>
            <div class="text">完成</div>
          </div>
        </div>
      </div>

      <!-- box -->
      <div id="box1">
        <div class="title">
          <h1>企业信息</h1>
        </div>
        <div class="line"></div>
        <div class="progressContent">
          <Form ref="information" :model="information" :rules="ruleValidate">

            <div class="flex-between-center">
              <div>
                <FormItem label="企业名称" prop="name">
                  <Input type="text" v-model="information.name" placeholder="请输入企业名称"></Input>
                </FormItem>
              </div>
              <div class="flex">
                <div>
                  <FormItem label="所属地区" prop="orea" style="width:157px;">
                    <Input type="password" v-model="information.orea" placeholder="请输入所属地区"></Input>
                  </FormItem>
                </div>
                <div>
                  <FormItem label="所属乡镇" prop="town" style="width:200px;margin-left:8px;">
                    <Select v-model="information.town">
                      <Option v-for="item in cityList" :value="item.value" :key="item.value">111</Option>
                    </Select>
                  </FormItem>
                </div>
              </div>
            </div>
            <div class="flex-between-center">
              <FormItem label="统一社会信用代码" prop="social">
                <Input type="text" v-model="information.social" placeholder="请输入统一社会信用代码"></Input>
              </FormItem>
              <FormItem label="企业性质" prop="nature">
                <Select v-model="information.nature">
                  <Option v-for="item in cityList" :value="item.value" :key="item.value">111</Option>
                </Select>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="注册资金（万元）" prop="money">
                <Input type="text" v-model="information.money" placeholder="请输入注册资金"></Input>
              </FormItem>
              <FormItem label="注册日期" prop="date">
                <DatePicker type="date" placeholder="…请选择注册日期…"></DatePicker>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="开户行" prop="bank">
                <Input type="text" v-model="information.bank" placeholder="请输入开户行"></Input>
              </FormItem>
              <FormItem label="银行账号" prop="bankNumber">
                <Input type="text" v-model="information.bankNumber" placeholder="请输入银行账号"></Input>
              </FormItem>
            </div>
            <FormItem label="企业地址" prop="address" style="width:100%;">
              <Input type="text" v-model="information.address" placeholder="请输入企业地址"></Input>
            </FormItem>
            <div class="flex-between-center">
              <FormItem label="邮编" prop="email">
                <Input type="text" v-model="information.email" placeholder="请输入邮编号码"></Input>
              </FormItem>
              <FormItem label="传真" prop="fax">
                <Input type="text" v-model="information.fax" placeholder="请输入传真号码"></Input>
              </FormItem>
            </div>
            <FormItem label="企业网址" prop="website">
              <Input type="text" v-model="information.website" placeholder="请输入企业网址"></Input>
            </FormItem>
            <FormItem label="企业简介" prop="introduction" style="width:100%">
              <Input v-model="information.introduction" type="textarea" :autosize="{minRows:4,maxRows: 5}" placeholder="请输入企业简介"></Input>
            </FormItem>
            <Button type="primary" @click="handleSubmit" class="next">提交</Button>
          </Form>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>

</template>

<script>
import { mapMutations } from "vuex";
import foot from "../components/footer";
export default {
  data() {
    return {
      step: 0,
      cityList: [],
      information: {}, //企业信息
      contactsInfo: {}, //联系人信息
      ruleValidate: {
        license: [
          { required: true, message: "企业营业执照不能为空", trigger: "blur" }
        ],
        name: [
          { required: true, message: "企业名称不能为空", trigger: "blur" }
        ],
        orea: [
          { required: true, message: "所属地区不能为空", trigger: "blur" }
        ],
        town: [
          { required: true, message: "所属乡镇不能为空", trigger: "change" }
        ],
        social: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur"
          }
        ],
        nature: [
          { required: true, message: "企业性质不能为空", trigger: "blur" }
        ],
        money: [
          { required: true, message: "注册资金不能为空", trigger: "blur" }
        ],
        date: [
          { required: true, message: "注册日期不能为空", trigger: "change" }
        ],
        bank: [{ required: true, message: "开户行不能为空", trigger: "blur" }],
        bankNumber: [
          { required: true, message: "银行账号不能为空", trigger: "blur" }
        ],
        address: [
          { required: true, message: "企业地址不能为空", trigger: "blur" }
        ]
      },
      ruleContacts: {
        name: [
          { required: true, message: "联系人姓名不能为空", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "联系人电话不能为空", trigger: "blur" }
        ],
        idCard: [
          { required: true, message: "联系人身份证号不能为空", trigger: "blur" }
        ],
        legalName: [
          { required: true, message: "法人姓名不能为空", trigger: "blur" }
        ],
        legalPhone: [
          { required: true, message: "法人电话不能为空", trigger: "blur" }
        ],
        legalIdcard: [
          { required: true, message: "法人身份证号不能为空", trigger: "blur" }
        ]
      },
      phoneUp: true,
      phoneDown: false,
      bgImg: false
    };
  },
  components: {
    foot
  },
  methods: {
    ...mapMutations(["setContentType", "setMenuName",]),
    goshouye: function () {
      this.setContentType(0)
      this.$router.push('/home')
    }

  }
};
</script>

<style lang="less" scoped>
.biangeng {
  width: 100%;
  .bgtj_sucess {
    width: 100%;
    height: 758px;
    background: #ffffff;
    border-radius: 10px;
    border-radius: 10px;
    h2 {
      width: 100%;
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #2c59c3;
      letter-spacing: 0.36px;
    }
    .lines {
      width: 860px;
      border: 1px solid #ebedf3;
      margin: 50px auto;
    }
    .nei {
      margin: 0 auto;
      width: 1200px;
      text-align: center;
      .nei-t {
        margin-top: 100px;
        width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 20px;
          width: 60px;
          height: 60px;
        }
        p {
          font-family: PingFangSC-Medium;
          font-size: 24px;
          color: #4a4a4a;
          letter-spacing: 0.45px;
        }
      }
      .nei-m {
        margin-top: 50px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.3px;
      }
      .nei-b1 {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #878787;
        letter-spacing: 0;
        margin-top: 300px;
      }
      .nei-b2 {
        width: 114px;
        height: 34px;
        background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.97) 0%,
          rgba(251, 251, 251, 0.98) 37%,
          #f5f5f5 100%
        );
        border: 1px solid #d8d8d8;
        border-radius: 4px;
        border-radius: 4px;
        margin: 30px auto;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        color: #878787;
        cursor: pointer;
      }
    }
  }
  nav {
    width: 100%;
    height: 34px;
    background: #f7f9fd;
    div {
      width: 1200px;
      margin: 0 auto;
      line-height: 34px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #616c84;
      letter-spacing: -0.43px;
    }
  }
  header {
    background-color: white;
    height: 80px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .kk {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #2c59c3;
      letter-spacing: 0.26px;
      cursor: pointer;
    }
    div {
      display: flex;
      align-items: center;
      span {
        margin-left: 20px;
        font-family: PingFangSC-Regular;
        font-size: 22px;
        color: #252a37;
        letter-spacing: 0.39px;
      }
      img {
        width: 122px;
      }
    }
  }
  .tabbar {
    height: 40px;
    width: 1200px;
    margin: 0 auto;
    border-bottom: 2px solid #d7dce7;
    .tabbox {
      height: 40px;
      width: 600px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tab1 {
        width: 120px;
        display: flex;
        align-items: center;
        height: 40px;

        .bg {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
          line-height: 24px;
          text-align: center;
          color: white;
        }
        .text {
          margin-left: 10px;
        }
      }
    }
  }
  #box1 {
    width: 1200px;
    margin: 0 auto;
    .title {
      line-height: 50px;
      width: 1200px;
      h1 {
        width: 1200px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #2c59c3;
        letter-spacing: 0.36px;
        text-align: center;
      }
    }

    .progressContent {
      width: 860px;
      margin: 20px auto;
      padding: 15px 0;
      border-top: 1px solid #ebedf3;
      // 企业信息
      .license {
        background: #ffffff;
        border: 1px solid #ccd1dd;
        border-radius: 4px;
        width: 368px;
        height: 210px;
        margin: 5px 0;
        text-align: center;
        .noImg {
          width: 320px;
          height: 180px;
          margin: 10px 10px;
        }
      }
      .msg {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #616c84;
        letter-spacing: 0.21px;
      }
      .upload {
        padding: 0;
        width: 117px;
        height: 26px;
        line-height: 26px;
        border: 0;
        outline: none;
      }
      .upload:first-child {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
      }
      /deep/ .ivu-btn-primary {
        background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
        margin: 0 10px;
      }
      // 表单label样式
      /deep/ .ivu-form .ivu-form-item-label {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0.26px;
        line-height: 20px;
      }
      .ivu-form-item {
        width: 368px;
      }
      /deep/ .ivu-input {
        height: 48px;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      }
      /deep/ .ivu-select-single .ivu-select-selection {
        height: 48px;
        line-height: 48px;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      }
      /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        line-height: 48px;
      }
      /deep/ .ivu-date-picker {
        display: block;
      }
      /deep/ .ivu-input-suffix {
        line-height: 48px;
      }
      /deep/ .ivu-select-dropdown {
        top: 84px !important;
      }
      .next {
        display: block;
        width: 368px;
        margin: auto;
        height: 48px;
      }
      // 联系人信息
      .imgBox {
        border-top: 1px solid #ebedf3;
        .imgMsg {
          margin: 10px 0;
          .txt {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #2c59c3;
            letter-spacing: 0.25px;
            font-weight: 600;
            margin-right: 10px;
          }
        }
        .must {
          color: #ed4014;
          margin-right: 4px;
          font-size: 12px;
          display: inline-block;
          font-family: SimSun;
        }
      }
    }
  }
}
.active {
  border-bottom: 2px solid #2c59c3 !important;
}
</style>
